<script>
  import Time from './Time.svelte';
  import Record from './Record.svelte';
  import { format, isBefore } from 'date-fns';
  import { validToInterval, intervalIsValid } from '@parkingboss/api';
  import { onMount } from 'svelte';

  const FMT = 'PP p';

  export let valid;

  let time = new Date();
  onMount(() => {
    const i = setTimeout(() => {
      time = new Date();
    }, 60 * 1000);
    return () => clearInterval(i);
  });

  $: interval = validToInterval(valid);
  $: graceInterval = valid && validToInterval(valid.grace);
  $: current = intervalIsValid(interval, time);
  $: minPast = isBefore(interval.start, time);
  $: maxPast = isBefore(interval.end, time);
  $: grace = !current && intervalIsValid(graceInterval, time);
  $: minFormatted = format(new Date(valid.min.local), FMT);
  $: maxFormatted = valid.max && valid.max.local && format(new Date(valid.max.local), FMT);
  $: minBy = valid.min.by || { display: 'Parking Attendant' };
  $: maxBy = valid.max && valid.max.by || { display: 'Parking Attendant' };
</script>

<time class='valid interval' class:current datetime={valid.interval}>
  <Time class='valid min {minPast ? 'past' : 'future'}'
    utc={valid.min.utc}
    local={valid.min.local}
    title={valid.min.title}
    user={minBy}
  />

  {#if valid.max}

  <Time class='valid max {maxPast ? 'past' : 'future'}'
    utc={valid.max.utc}
    local={valid.max.local}
    title={valid.max.title}
    user={maxBy}
  />

  {:else}

  <Time class='valid max future' utc=''>Until Revoked</Time>

  {/if}


  <Time class={[ 'grace', grace && 'current' ]} utc={valid.grace.interval}>
    {#if grace}
    Grace Period
    {/if}
  </Time>
</time>
